/**
 * История версий пакета (ТЗ FR-31).
 *
 * Файлы лежат в папке дела на Диске Битрикс24, версия определяется по имени
 * файла (правило именования FR-30). Отдельного хранилища версий нет —
 * это сознательное решение: одна копия документов, а не две.
 */

import { useEffect, useState } from 'react';
import { api } from '../../api.js';

export function VersionList({
  caseId,
  folderId,
  reloadKey,
}: {
  caseId: string;
  folderId?: string;
  /** Меняется после формирования пакета: список перечитывается */
  reloadKey?: number;
}) {
  const [versions, setVersions] = useState<Array<{ version: number; files: Array<{ id: string; name: string; downloadUrl?: string; createTime?: string }> }>>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .versions(caseId, folderId)
      .then((r) => setVersions(r.versions))
      .catch((e) => setError((e as Error).message));
  }, [caseId, folderId, reloadKey]);

  if (error) return <p className="warning">История версий недоступна: {error}</p>;
  if (versions.length === 0) return <p className="hint">Пакет ещё не формировался.</p>;

  return (
    <ul className="versions">
      {versions.map((version) => (
        <li key={version.version}>
          <strong>Версия {version.version}</strong>
          <ul>
            {version.files.map((file) => (
              <li key={file.id}>
                {file.downloadUrl ? (
                  <a href={file.downloadUrl} target="_blank" rel="noreferrer">
                    {file.name}
                  </a>
                ) : (
                  file.name
                )}
                {file.createTime && <span className="hint"> · {new Date(file.createTime).toLocaleString('ru-RU')}</span>}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
}
